import { helper } from '@ember/component/helper';
export default helper(function add(params) {
  const isNumber = params.every(function (element) {
    return typeof element === 'number' && !Number.isNaN(element);
  });
  if (!isNumber) {
    return 'N/A';
  }
  const total = params.reduce((acc, curr) => acc + curr, 0);
  return total;
});